import api from '@/api';

const Main = ({
    typeId = 1,
    interactiveGroup = null,
    hasAds = true,
    userHasPremium = false,
    availableLists = [],
    initialPage = 1,
    initialSort = '',
    initialList = [],
    initialListLength = 0,
    initialIsEmpty = false,
    initialColumns = 1,
    initialSubject = '',
    initialDemographic = '',
    initialSubjectTitle = '',
    initialDemographicTitle = '',
    initialHeading = ''
}) => {
    return {
        baseUrl: '',
        loading: false,
        userHasPremium: userHasPremium,
        heading: initialHeading,
        availableLists: availableLists,
        page: initialPage,
        sort: initialSort,
        list: initialList,
        listLength: initialListLength,
        isEmpty: initialIsEmpty,
        columns: initialColumns,
        subject: initialSubject,
        demographic: initialDemographic,
        subjectTitle: initialSubjectTitle,
        demographicTitle: initialDemographicTitle,
        width: window.innerWidth,

        init () {
            this.$nextTick(() => document.getElementById('skeleton')?.remove());

            const url = new URL(window.location);

            this.baseUrl = url.pathname.split('/')[1];

            this.$watch('sort', async () => await this.setList());
            this.$watch('columns', () => this.insertAd());
            this.$watch('list', () => this.$dispatch('update-thumb'));
            this.$watch('listLength', () => this.$dispatch('list-length'));
            window.addEventListener('resize', () => this.width = window.innerWidth);

            this.insertAd();
        },

        setFilter(type, slug, title) {
            this[type] = slug === this[type] ? 'none' : slug;

            this[type + 'Title'] = this[type] === 'none' ? '' : title;

            this.setUrl();

            this.$dispatch('reset-page');
        },

        async setList() {
            this.loading = true;

            await api.get('/list', {
                params: {
                    typeId: typeId,
                    interactiveGroup: interactiveGroup,
                    subject: this.subject,
                    demographic: this.demographic,
                    sort: this.sort,
                    page: this.page
                }
            }).then(({ data: response }) => {
                const { data, isEmpty, meta, tools } = response;
                const { title, heading, total } = meta;

                this.list       = data;
                this.isEmpty    = isEmpty;
                this.listLength = total;
                this.heading    = heading;

                document.title = title;

                if (this.isEmpty) {
                    this.$nextTick(() => {
                        this.$dispatch('content-list-filter', false);
                        this.$dispatch('update-button-wide', tools.results);
                        this.$dispatch('update-article-card', tools.articles);
                        this.$dispatch('update-interactive-card', tools.interactives);
                    });
                }

                this.insertAd();
            }).finally(() => {
                this.loading = false;
            });
        },

        setUrl() {
            const url = new URL(window.location);

            const { existingFilter: existingDemographic, filter: demographic } = this.handleDirtyFilter(this.demographic);
            const { existingFilter: existingSubject, filter: subject } = this.handleDirtyFilter(this.subject);

            url.pathname = existingSubject && subject !== 'none' || existingDemographic && demographic !== 'none'
                ? [this.baseUrl, subject, demographic].join('/')
                : this.baseUrl;

            window.history.replaceState({}, '', url);
        },

        handleDirtyFilter(dirtyFilter){
            const existingFilter = typeof dirtyFilter !== 'undefined' && dirtyFilter !== 'none';
            const filter = typeof dirtyFilter === 'undefined' || dirtyFilter === 'undefined' ? 'none' : dirtyFilter;

            return { existingFilter, filter };
        },

        insertAd() {
            const newPosition = this.getAdPositionByColumns();

            if (!hasAds || this.isEmpty) {
                return;
            }

            const oldPosition = this.findAd();

            if (oldPosition == newPosition) {
                return;
            }

            this.removeAd(oldPosition);

            if (this.list.length > newPosition) {
                this.list.splice(newPosition, 0, {ads: true});
            }
        },

        findAd() {
            return this.list.findIndex((content) => content.ads);
        },

        getAdPositionByColumns() {
            const positions = {1: 3, 2: 4, 3: 6};
            return positions[this.columns] ?? 6;
        },

        removeAd(position) {
            if (position < 0) {
                return;
            }

            this.list.splice(position, 1);
        }
    }
}

export default Main;
